import { SUCCESS } from "../../../../../constants/action-postfix";
import { STUDENTS_INFO_REQUEST } from "../../studentsInfoReducer";


const initialState = null;

export const dischargedReducer = (state = initialState, action) => {
    switch (action.type) {
        case `${STUDENTS_INFO_REQUEST}${SUCCESS}`:
            return action.payload.discharged;
        default:
            return state;
    }
};
